import Vue from 'vue';
import Router from 'vue-router';
import Login2 from '@/views/login2.vue';
// import opertaingMaintenanceRoute from '@/router/operating-maintenance/index';
// import equipmentLedgerRoute from '@/router/equipment-ledger/index';
import equipmentOperationalRoute from '@/router/equipment-operational/index';
// import systemManageRouter from '@/router/system-manage/index';
import systemSafetyRoute from '@/router/system-safety/index';

Vue.use(Router);
// Home route content
export const homeRoute = {
  path: '/home',
  name: 'Home',
  component: () =>
    import('@/views/Home.vue'),
  redirect: {
    name: 'light-map-index',
  },
  children: [{
    path: 'light-map-index',
    name: 'light-map-index',
    meta: {
      title: '项目总览',
      icon: 'el-icon-s-home',
    },
    component: () =>
      import('@/components/index/light-map-index.vue'),
  }, {
    path: 'realtime-monitoring',
    name: 'realtime-monitoring',
    meta: {
      title: '实时监测',
      icon: 'el-icon-s-marketing',
    },
    component: () =>
      import('@/components/realtime-monitoring/index.vue'),
    children: [{
      path: 'ele-situation',
      name: 'ele-situation',
      meta: {
        title: '用电概况',
        icon: 'el-icon-pie-chart',
      },
      component: () =>
        import(
          '@/components/realtime-monitoring/ele-situation/index.vue'
        ),
    }, {
      path: 'switchroom-monitoring',
      name: 'switchroom-monitoring',
      meta: {
        title: '配电室监测',
        icon: 'el-icon-office-building',
      },
      component: () =>
        import(
          '@/components/realtime-monitoring/switchroom-monitoring/index.vue'
        ),
    }, {
      path: 'video-monitor',
      name: 'video-monitor',
      meta: {
        title: '视频监控',
        icon: 'el-icon-video-camera',
      },
      component: () =>
        import(
          '@/components/realtime-monitoring/video-monitor/index.vue'
        ),
    }, {
      path: 'equipments-condition',
      name: 'equipments-condition',
      meta: {
        title: '设备工况',
        icon: 'el- -box',
      },
      component: () =>
        import(
          '@/components/realtime-monitoring/equipments-condition/index.vue'
        ),
    }, {
      path: 'equipment_details',
      name: 'equipment_details',
      meta: {
        title: '设备工况详情跳转页面',
        icon: 'el-icon-box',
      },
      component: () =>
        import(
          '@/components/realtime-monitoring/equipment_details/equipment_details.vue'
        ),
    }, {
      path: 'workorder-management',
      name: 'workorder-management',
      meta: {
        title: '告警详情',
        icon: 'el-icon-s-order',
      },
      component: () =>
        import(
          '@/components/realtime-monitoring/workorder-management/index.vue'
        ),
      activeIndex: 'alarm-table',
      isShow: false,
    }],
  }, {
    path: 'data-analysis',
    name: 'data-analysis',
    meta: {
      title: '能效管理23',
      icon: 'el-icon-s-help',
    },
    component: () =>
      import('@/components/data-analysis/index.vue'),
    children: [{
      path: 'query-pivot',
      name: 'query-pivot',
      meta: {
        title: '数据查询',
        icon: 'el-icon-news',
      },
      component: () =>
        import('@/components/energy-efficiency/query-pivot.vue'),
    }, {
      path: 'auxiliary-analysis',
      name: 'auxiliary-analysis',
      meta: {
        title: '统计分析',
        icon: 'el-icon-reading',
      },
      component: () =>
        import(
          '@/components/data-analysis/auxiliary-analysis/index1.vue'
        ),
    }, {
      path: 'run-report',
      name: 'run-report',
      meta: {
        title: '运行报表',
        icon: 'el-icon-document',
      },
      component: () =>
        import('@/components/run-report/index.vue'),
    }, {
      path: 'state-evaluation',
      name: 'state-evaluation',
      meta: {
        title: '状态评价',
        icon: 'el-icon-document-checked',
      },
      component: () =>
        import(
          '@/components/data-analysis/state-evaluation/index.vue'
        ),
    }, {
      path: 'energy-consumption-statistics',
      name: 'energy-consumption-statistics',
      meta: {
        title: '能耗统计',
        icon: 'el-icon-takeaway-box',
      },
      component: () =>
        import(
          '@/components/data-analysis/energy-consumption-statistics/index.vue'
        ),
    }],
  },
  {
    path: 'cost-control-management',
    name: 'cost-control-management',
    meta: {
      title: '费控管理',
      icon: 'el-icon-s-ticket',
    },
    component: () => import('@/components/cost-control-management/index.vue'),
    children: [{
      path: 'merchant-list',
      name: 'merchant-list',
      meta: {
        title: '商户列表',
        icon: 'el-icon-suitcase-1',
      },
      component: () => import(
        '@/components/cost-control-management/merchant-list.vue'
      ),
    }, {
      path: 'supply-meter-list',
      name: 'supply-meter-list',
      meta: {
        title: '户表列表',
        icon: 'el-icon-cpu',
      },
      component: () => import(
        '@/components/cost-control-management/supply-meter-list.vue'
      ),
    }, {
      path: 'energy-list/:id',
      name: 'energy-list',
      meta: {
        title: '用电记录',
        icon: 'el-icon-s-help',
      },
      component: () => import(
        '@/components/cost-control-management/energy-list.vue'
      ),
      activeIndex: 'supply-meter-list',
      isShow: false,
    }, {
      path: 'bill-records/:id',
      name: 'bill-records',
      meta: {
        title: '账单记录',
        icon: 'el-icon-s-help',
      },
      component: () => import(
        '@/components/cost-control-management/bill-records.vue'
      ),
      activeIndex: 'merchant-list',
      isShow: false,
    }, {
      path: 'energy-analysis-1',
      name: 'energy-analysis-1',
      meta: {
        title: '用能分析',
        icon: 'el-icon-s-help',
      },
      component: () => import(
        '@/components/cost-control-management/energy-analysis.vue'
      ),
      activeIndex: 'supply-meter-list',
      isShow: false,
    }, {
      path: 'contrast/:id',
      name: 'contrast',
      meta: {
        title: '对比分析',
        icon: 'el-icon-s-help',
      },
      component: () => import(
        '@/components/contrast/contrast.vue'
      ),
      activeIndex: 'supply-meter-list',
      isShow: false,
    },
    {
      path: 'peakvalley/:id',
      name: 'peakvalley',
      meta: {
        title: '峰谷分析',
        icon: 'el-icon-s-help',
      },
      component: () => import(
        '@/components/peakvalley/peakvalley.vue'
      ),
      activeIndex: 'supply-meter-list',
      isShow: false,
    },
    {
      path: 'recharge-record/:id',
      name: 'recharge-record',
      meta: {
        title: '充值记录',
        icon: 'el-icon-s-help',
      },
      component: () => import(
        '@/components/cost-control-management/recharge-record/index.vue'
      ),
      activeIndex: 'merchant-list',
      isShow: false,
    },
    ],
  },
  {
    path: 'energy-analysis',
    name: 'energy-analysis',
    meta: {
      title: '用能分析',
      icon: 'el-icon-s-data',
    },
    component: () =>
      import('@/components/cost-control-management/index.vue'),
    children: [{
      path: 'energy-query',
      name: 'energy-query',
      meta: {
        title: '用能查询',
        icon: 'el-icon-set-up',
      },
      component: () =>
        import(
          '@/components/energy-analysis/energy-query.vue'
        ),
    }, {
      path: 'contrastive-analysis',
      name: 'contrastive-analysis',
      meta: {
        title: '对比分析',
        icon: 'el-icon-money',
      },
      component: () =>
        import(
          '@/components/energy-analysis/contrastive-analysis.vue'
        ),
    }, {
      path: 'peak-valley-analysis',
      name: 'peak-valley-analysis',
      meta: {
        title: '峰谷分析',
        icon: 'el-icon-data-line',
      },
      component: () =>
        import(
          '@/components/energy-analysis/peak-valley-analysis.vue'
        ),
    }, {
      path: 'load-analysis',
      name: 'load-analysis',
      meta: {
        title: '负载分析',
        icon: 'el-icon-files',
      },
      component: () =>
        import(
          '@/components/energy-analysis/load-analysis.vue'
        ),
    }],
  },
  {
    path: 'Operation',
    name: 'Operation',
    meta: {
      title: '运维档案',
      icon: 'el-icon-s-management',
    },
    component: () =>
      import('@/components/Operation/index.vue'),
    children: [{
      path: 'equipment',
      name: 'equipment',
      meta: {
        title: '设备档案',
        icon: 'el-icon-bangzhu',
      },
      component: () =>
        import('@/components/Operation/equipment/equipment.vue'),
    }, {
      path: 'Operations',
      name: 'Operations',
      meta: {
        title: '运维档案',
        icon: 'el-icon-coin',
      },
      component: () =>
        import('@/components/Operation/Operation/Operation.vue'),
    }],
  },
  {
    path: 'alarm-table',
    name: 'alarm-table',
    meta: {
      title: '告警事件',
      icon: 'el-icon-message-solid',
    },
    component: () =>
      import('@/components/alarm-table/index.vue'),
  },
    equipmentOperationalRoute,
    systemSafetyRoute,
  // opertaingMaintenanceRoute,
  // equipmentLedgerRoute,
  {
    path: 'work-detail/:id/:wId?',
    name: 'work-detail',
    meta: {
      title: 'work-detail',
      icon: 'el-icon-s-help',
    },
    component: () =>
      import('@/components/equipment-operational/components/work-detail/index.vue'),
    activeIndex: 'equipment-operational',
    isShow: false,
  },
  {
    path: 'svg-edit',
    name: 'svg-edit',
    meta: {
      title: '一次图编辑',
      icon: 'el-icon-message-solid',
    },
    component: () =>
      import('@/components/svg-edit/index.vue'),
    children: [{
      path: 'edit',
      name: 'edit',
      meta: {
        title: '绘制svg',
        icon: 'el-icon-bangzhu',
      },
      component: () =>
        import('@/components/svg-edit/edit/index.vue'),
    }, {
      path: 'sacn',
      name: 'sacnSvg',
      meta: {
        title: 'svg预览',
        icon: 'el-icon-coin',
      },
      component: () =>
        import('@/components/svg-edit/scan/index.vue'),
    }],
  },
  {
    path: 'self-work-detail/:id?',
    name: 'self-work-detail',
    meta: {
      title: 'self-work-detail',
      icon: 'el-icon-s-help',
    },
    component: () => import('@/components/equipment-operational/components/work-detail/selfCreated.vue'),
    activeIndex: 'equipment-operational',
    isShow: false,
  },
  {
    path: 'personal-center',
    name: 'personal-center',
    meta: {
      title: '个人中心',
      icon: 'el-icon-s-custom',
    },
    component: () => import('@/components/personal-center/index.vue'),
    children: [{
      path: 'apply',
      name: 'apply',
      meta: {
        title: '申请',
        icon: 'el-icon-mobile',
      },
      component: () => import(
        '@/components/personal-center/apply.vue'
      ),
    }, {
      path: 'my-repairs',
      name: 'my-repairs',
      meta: {
        title: '我的抢修',
        icon: 'el-icon-first-aid-kit',
      },
      component: () => import(
        '@/components/personal-center/my-repairs.vue'
      ),
    }, {
      path: 'my-tests',
      name: 'my-tests',
      meta: {
        title: '我的试验',
        icon: 'el-icon-guide',
      },
      component: () => import(
        '@/components/personal-center/my-tests.vue'
      ),
    }, {
      path: 'ele-waiters',
      name: 'ele-waiters',
      meta: {
        title: '运维技师',
        icon: 'el-icon-truck',
      },
      component: () => import(
        '@/components/personal-center/ele-waiters.vue'
      ),
    }, {
      path: 'reports-tabs',
      name: 'reports-tabs',
      meta: {
        title: '方案报告',
        icon: 'el-icon-tickets',
      },
      component: () => import(
        '@/components/personal-center/reports-tabs.vue'
      ),
    }, {
      path: 'personal-info-setting',
      name: 'personal-info-setting',
      meta: {
        title: '个人信息设置',
        icon: 'el-icon-collection-tag',
      },
      component: () => import('@/components/personal-center/personal-info-setting.vue'),
    }],
  },
    // systemManageRouter,
  ],
};
export const routes = [{
  path: '/',
  name: 'Login',
  component: Login2,
},
  homeRoute,
{
  path: '*',
  name: '404',
  meta: {
    title: '404',
    icon: 'el-icon-s-help',
  },
  component: () =>
    import('@/components/err-pages/404.vue'),
  activeIndex: 'light-map-index',
  isShow: false,
}
];
const createRouter = () => new Router({
  routes,
});
const router = createRouter();

export function resetRouter() {
  console.log('resetRouter');
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;